module.exports = __webpack_public_path__ + "static/img/login.328e773a.svg";